import React from "react";
import styles from "./styles.module.css";
import clsx from "clsx";

interface AccordionProps {
  children: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ children }) => {
  return <div className={clsx(styles.accordion)}>{children}</div>;
};

export default Accordion;
